export enum MenuItems {
  HOME = 'home',
  PROJECTS = 'projects',
  RESUME = 'resume',
  CERTIFICATES = 'certificates',
  ABOUT = 'about',
  // HOBBY = 'hobby',
  CONTACT = 'contact',
}
